<template>
  <vx-card v-if="isQuotation" class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered w-full table-pt">
      <tr class="title p-1 w-full">
        <th colspan="12">PAGAMENTO</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>Prêmio Líquido</b>:
          {{ functions.formataReal(prizeData.tariff_prize) }}
        </td>
        <td class="pl-3">
          <b>IOF</b>: {{ functions.formataReal(prizeData.iof_value) }}
        </td>
        <td class="pl-3">
          <b>Prêmio Total</b>: {{ functions.formataReal(prizeData.prize) }}
        </td>
      </tr>
    </table>

    <table
      v-for="(item, index) in quotationData.paymentMethods"
      :key="index"
      class="table table-bordered table-striped-col"
      v-if="
        endorsementData &&
        endorsementData.prize &&
        endorsementData.prize.prize > 0
      "
    >
      <tr class="title p-1 w-full">
        <th :colspan="item.installments.length" class="uppercase">
          {{ item.method }}
        </th>
      </tr>

      <tr>
        <td
          v-for="(parcela, i) in item.installments"
          :key="`p-${i}`"
          class="font-small"
        >
          <b>{{ extractLabel(parcela.label, 'parcelas') }}</b>
        </td>
      </tr>

      <tr>
        <td
          v-for="(parcela, i) in item.installments"
          :key="`v-${i}`"
          class="font-small"
        >
          {{ extractLabel(parcela.label, 'valor') }}
        </td>
      </tr>

      <tr>
        <td
          v-for="(parcela, i) in item.installments"
          :key="`j-${i}`"
          class="font-xsmall"
        >
          {{ extractLabel(parcela.label, 'juros') }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.PAYMENT"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.PAYMENT"
    ></div>
  </vx-card>
  <vx-card v-else class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="4">PAGAMENTO</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>Prêmio Líquido</b>:
          {{ functions.formataReal(prizeData.tariff_prize) }}
        </td>
        <td class="pl-3">
          <b>IOF</b>:
          {{ functions.formataReal(prizeData.iof_value) }}
          <td class="pl-3">
            <b>Juros</b>:
            {{ functions.formataReal(prizeData.interest) }}
          </td>
        </td>
        <td class="pl-3">
          <b>Prêmio Final</b>:
          {{ functions.formataReal(prizeData.prize) }}
        </td>
      </tr>
      <tr>
        <td class="pl-3" v-if="prizeData.prize !== 0">
          <span v-if="prizeData.prize > 0">
            <b>Forma de Pagamento</b>: {{ proposalData.nomePagamento }}</span
          >
          <span v-if="prizeData.prize < 0">
            <b>Forma de Restituição</b>:
            {{ getRefundMethodName(previousPolicy.paymentMethod) }}
          </span>
        </td>
        <td class="pl-3" v-if="showInstallments() && prizeData.prize > 0">
          <b>Nº de Parcelas</b>: {{ endorsementData.prize.installments }} x
          {{ functions.formataReal(endorsementData.prize.monthlyPrize) }}
        </td>
        <td class="pl-3" colspan="2" v-if="prizeData.prize > 0 && dueDate">
          <b>Dia de Vencimento</b>:
          {{
            dueDate
          }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.PAYMENT"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.PAYMENT"
    ></div>
  </vx-card>
</template>

<script>
import { PAYMENT_METHODS, PURCHASE_STATUS } from '../../../utils/constants';
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractPayment',
  props: {
    isQuotation: {
      type: Boolean,
      required: false,
      default: false,
    },
    quotationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    previousPolicy: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    endorsementData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    prizeData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    dueDate() {
      if (
        this.proposalData.nomePagamento === PAYMENT_METHODS.CREDIT_CARD.name 
      ) {
        return this.creditCardDueDate;
      }

      return this.proposalData.diaVencimentoMensalidade;
    },
  },
  data() {
    return {
      functions,
      PURCHASE_STATUS,
      creditCardDueDate: 'De acordo com a fatura',
    };
  },
  methods: {
    getRefundMethodName(refundMethod) {
      if (
        refundMethod &&
        refundMethod.toLowerCase() === PAYMENT_METHODS.BILLET.name.toLowerCase()
      ) {
        return 'Transferência Bancária';
      }
      return refundMethod;
    },
    showInstallments() {
      if (
        this.proposalData.nomePagamento !== PAYMENT_METHODS.CREDIT_CARD.name
      ) {
        return true;
      }

      if (
        this.proposalData.purchaseStatus === PURCHASE_STATUS.AUTHORIZED ||
        this.proposalData.purchaseStatus === PURCHASE_STATUS.OVERPAID ||
        this.proposalData.purchaseStatus === PURCHASE_STATUS.PAID
      ) {
        return true;
      }

      return false;
    },
    extractLabel(label, type) {
      const [parcelaPart, valorPart] = label.split(' ');

      if (type === 'parcelas') return parcelaPart;
      if (type === 'valor') return valorPart + ' ' + label.split(' ')[2];
      if (type === 'juros')
        return label.toLowerCase().includes('sem juros')
          ? 'sem juros'
          : 'com juros';

      return '';
    },
  },
};
</script>
